export default "__VITE_ASSET__P7$jqMml__"